import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TEXT } from '../../constants/text';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  imports: [],
  templateUrl: './login-landing.html',
  styleUrl: './login-landing.scss',
})
export class LoginLandingComponent implements OnInit {
  private auth = inject(AuthService);
  private router = inject(Router);

  protected readonly T = TEXT;

  async ngOnInit() {
    await this.auth.handleRedirect();
    const isInitialized = await this.auth.initializeAuth();

    if (isInitialized) {
      await this.router.navigate(['/dashboard']);
      return;
    }

    if (this.auth.isPolicyAccessDenied()) {
      await this.router.navigate(['/access-denied'], {
        queryParams: this.auth.getPolicyAccessDeniedQueryParams(),
      });
      return;
    }

    await this.router.navigate(['/login']);
  }
}
